import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { NzI18nService, en_US, it_IT } from 'ng-zorro-antd/i18n';
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly LANGUAGE_KEY = 'selectedLanguage';

  languages = [
    { code: 'en', label: 'English', flag: 'assets/icons/en.png' },
    { code: 'it', label: 'Italiano', flag: 'assets/icons/it.png' },
  ];

  private currentLanguage = new BehaviorSubject<string>('en');
  currentLanguage$ = this.currentLanguage.asObservable();

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private nzI18nService: NzI18nService
  ) {
    const savedLanguage = localStorage.getItem(this.LANGUAGE_KEY) || 'en';
    this.currentLanguage.next(savedLanguage);
    this.translateService.use(savedLanguage).subscribe();
  }

  getCurrentLanguage(): string {
    return this.currentLanguage.getValue();
  }

  changeLanguage(language: string, navigate: boolean = true) {
    if (this.languages.some(lang => lang.code === language)) {
      if (this.getCurrentLanguage() === language) {
        // Language is already set; no need to change
        return;
      }
      this.currentLanguage.next(language);
      localStorage.setItem(this.LANGUAGE_KEY, language);
      this.translateService.use(language).subscribe();
      this.updateNzLocale(language);
      if (navigate) {
        // Navigate to the same route with the new language
        const urlTree = this.router.parseUrl(this.router.url);
        const root = urlTree.root;
        const primaryOutlet = root.children['primary'];
  
        let newUrlSegments: string[];
  
        if (primaryOutlet && primaryOutlet.segments.length > 0) {
          const segments = primaryOutlet.segments;
          newUrlSegments = [language, ...segments.slice(1).map(segment => segment.path)];
        } else {
          this.router.navigate([language]);
          return; 
        }
  
        this.router.navigate(newUrlSegments);
      }
    } else {
    }
  }

  private updateNzLocale(language: string) {
    switch (language) {
        case 'en':
            this.nzI18nService.setLocale(en_US);
            break;
        case 'it':
            this.nzI18nService.setLocale(it_IT);
            break;
        default:
            this.nzI18nService.setLocale(en_US);
    }
}
}
